module.exports = __webpack_public_path__ + "img/chevron-solid.9ed712cd.svg";